module.exports = __webpack_public_path__ + "static/media/filter.41302967.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/filter.svg
// module id = 310
// module chunks = 0